import { Grid, Briefcase, Users } from "react-feather";
import QrCodeIcon from "@mui/icons-material/QrCode";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";

export type SidebarItemsType = {
  Link: string;
  Name: string;
  Icon: React.FC<any>;
  children?: SidebarItemsType[];
  badge?: string;
};

var elementsSectionForSupport = [
  {
    Link: "/",
    Icon: Grid,
    Name: "Dashboard"
  },
  {
    Link: "/business-search",
    Icon: Briefcase,
    Name: "Business"
  },
  {
    Link: "/users",
    Icon: Users,
    Name: "Users"
  },
  {
    Link: "/generate-user-qrcodes",
    Icon: QrCodeIcon,
    Name: "Generate User Qrcodes"
  },
  {
    Link: "/tech-tools",
    Icon: BuildOutlinedIcon,
    Name: "Tech"
  }
] as SidebarItemsType[];

if (process.env.REACT_APP_ENV_NAME === "int") {
}

const TopSection = [] as SidebarItemsType[];

const menuItems = [
  {
    title: "",
    role: "all",
    pages: TopSection
  },
  {
    title: "",
    role: "Support",
    pages: elementsSectionForSupport
  }
];

export default menuItems;
